var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid p-5 banner"},[_c('div',{staticClass:"row align-items-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-10"},[_vm._v("\n            "+_vm._s(_vm.banner.content)+"\n        ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-2"},[_c('img',{staticClass:"img-fluid",staticStyle:{"width":"80%"},attrs:{"src":"assets/images/alert.svg"}})])
}]

export { render, staticRenderFns }